"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidgets = exports.getUI = exports.getSettings = exports.getOnGetHotelStat = exports.getLang = exports.getGoogleMapApiKey = exports.getCallbacks = exports.getBasePath = void 0;
var _ramda = require("ramda");
var _config = require("./config");
var getOnGetHotelStat = exports.getOnGetHotelStat = (0, _ramda.pipe)(_config.getConfig, (0, _ramda.prop)('onGetHotelStat'));
var getGoogleMapApiKey = exports.getGoogleMapApiKey = (0, _ramda.pipe)(_config.getConfig, (0, _ramda.prop)('google_maps_api_key'));
var getLang = exports.getLang = (0, _ramda.pipe)(_config.getConfig, (0, _ramda.prop)('lang'));
var getBasePath = exports.getBasePath = (0, _ramda.pipe)(_config.getConfig, (0, _ramda.propOr)('', 'basePath'));
var getWidgets = exports.getWidgets = (0, _ramda.pipe)(_config.getConfig, (0, _ramda.prop)('widgets'));
var getUI = exports.getUI = (0, _ramda.pipe)(_config.getConfig, (0, _ramda.prop)('ui'));
var getCallbacks = exports.getCallbacks = (0, _ramda.pipe)(_config.getConfig, (0, _ramda.prop)('callbacks'));
var getSettings = exports.getSettings = (0, _ramda.pipe)(_config.getConfig, (0, _ramda.prop)('settings'));